var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticStyle: { padding: "15px" } },
    [
      Object.keys(_vm.selectedStudent).length > 0
        ? [
            _vm.dataIsLoaded
              ? _c(
                  "div",
                  [
                    _vm.districtDesc.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-xs-offset-0 text-primary",
                            staticStyle: {
                              "border-top": "1px solid",
                              "border-bottom": "1px solid",
                              "text-align": "center"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("commonText.SMSDisclosure", {
                                    district_desc: _vm.districtDesc
                                  })
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedStudent.RESTRICTED_ACCOUNT_FLG !== "Y"
                      ? _c(
                          "div",
                          { staticClass: "row" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-xs-6 col-xs-offset-3",
                                staticStyle: { "text-align": "center" }
                              },
                              [
                                _c("h3", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t("" + _vm.getHeaderTitle(1))
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.studentDataFields.GROUPS["1"].C_ARRAY,
                              function(column, columnIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: "displayOptions_" + columnIndex,
                                    staticClass: "col-xs-12 col-md-4",
                                    staticStyle: { "min-height": "110px" }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-12" },
                                        [
                                          !!_vm.studentDataFields.GROUPS["1"]
                                            .COLUMNS[column].HELP_TEXT
                                            ? [
                                                _c("font-awesome-icon", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName:
                                                        "v-tooltip.top-center",
                                                      value: {
                                                        content:
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .HELP_TEXT,
                                                        trigger: "hover click"
                                                      },
                                                      expression:
                                                        "{content: studentDataFields.GROUPS['1'].COLUMNS[column].HELP_TEXT, trigger: 'hover click'}",
                                                      modifiers: {
                                                        "top-center": true
                                                      }
                                                    }
                                                  ],
                                                  attrs: {
                                                    icon: "question-circle"
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              class: { changeRequest: false },
                                              staticStyle: {
                                                "font-weight": "bold",
                                                display: "inline"
                                              },
                                              attrs: {
                                                for:
                                                  "GROUPS_1_COLUMNS_" +
                                                  column +
                                                  "_INDEX_" +
                                                  columnIndex
                                              }
                                            },
                                            [
                                              !!_vm.STUDENTTEXT[column]
                                                ? [
                                                    _vm.STUDENTTEXT[column]
                                                      .length > 0 &&
                                                    _vm.$t(
                                                      _vm.STUDENTTEXT[column]
                                                    ).length > 0
                                                      ? [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  _vm
                                                                    .STUDENTTEXT[
                                                                    column
                                                                  ]
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm
                                                                  .studentDataFields
                                                                  .GROUPS["1"]
                                                                  .COLUMNS[
                                                                  column
                                                                ].FIELD_LABEL
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .FIELD_LABEL
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        ],
                                        2
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.studentDataFields.GROUPS["1"].COLUMNS[
                                      column
                                    ].SAP_FIELD.includes("FLG")
                                      ? [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-xs-12" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c("sapphire-toggle", {
                                                      staticClass:
                                                        "col-xs-6 col-md-4 col-lg-3",
                                                      attrs: {
                                                        ariaLabel: _vm.getAriaMessage(
                                                          1,
                                                          column,
                                                          _vm.STUDENTTEXT
                                                        )
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.saveChangedValue(
                                                            _vm
                                                              .formFieldSelectedValues
                                                              .STUDENT[
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            ]
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .formFieldSelectedValues
                                                            .STUDENT[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["1"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          ].VALUE,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm
                                                              .formFieldSelectedValues
                                                              .STUDENT[
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            ],
                                                            "VALUE",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].VALUE !==
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].OLD_VALUE
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.top-center",
                                                          value: {
                                                            content: _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                            ),
                                                            trigger:
                                                              "hover click"
                                                          },
                                                          expression:
                                                            "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                          modifiers: {
                                                            "top-center": true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "col-xs-12 current"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon:
                                                            "exclamation-triangle"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                              {
                                                                choice:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .STUDENT[
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "1"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ]
                                                                    .OLD_VALUE ===
                                                                  "Y"
                                                                    ? _vm.$t(
                                                                        "MAIN_CONTENT.commonContent.yesLabel"
                                                                      )
                                                                    : _vm.$t(
                                                                        "MAIN_CONTENT.commonContent.noLabel"
                                                                      )
                                                              }
                                                            )
                                                          ) +
                                                          " \n\t\t\t\t\t\t\t"
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : _vm.studentDataFields.GROUPS["1"]
                                          .COLUMNS[column].USE_CODEX.length > 0
                                      ? [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-xs-12" },
                                              [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm
                                                            .formFieldSelectedValues
                                                            .STUDENT[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["1"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          ].VALUE,
                                                        expression:
                                                          "formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      "aria-label":
                                                        _vm.studentDataFields
                                                          .GROUPS["1"]
                                                          .DV_GROUP_DESC +
                                                        ", " +
                                                        _vm.studentDataFields
                                                          .GROUPS["1"].COLUMNS[
                                                          column
                                                        ].FIELD_LABEL +
                                                        ", " +
                                                        _vm
                                                          .formFieldSelectedValues
                                                          .STUDENT[
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .SAP_FIELD
                                                        ].VALUE,
                                                      disabled: !!_vm.disabledMap[1].includes(
                                                        _vm.studentDataFields
                                                          .GROUPS["1"].COLUMNS[
                                                          column
                                                        ].SAP_FIELD_RID
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$selectedVal = Array.prototype.filter
                                                          .call(
                                                            $event.target
                                                              .options,
                                                            function(o) {
                                                              return o.selected
                                                            }
                                                          )
                                                          .map(function(o) {
                                                            var val =
                                                              "_value" in o
                                                                ? o._value
                                                                : o.value
                                                            return val
                                                          })
                                                        _vm.$set(
                                                          _vm
                                                            .formFieldSelectedValues
                                                            .STUDENT[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["1"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          ],
                                                          "VALUE",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      }
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.studentDataCodex[
                                                      _vm.studentDataFields
                                                        .GROUPS["1"].COLUMNS[
                                                        column
                                                      ].USE_CODEX
                                                    ],
                                                    function(codex, key) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: "CODEX_" + key,
                                                          domProps: {
                                                            value:
                                                              codex.DICT_CODE
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                codex.DICT_DESC
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t\t"
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].VALUE !==
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].OLD_VALUE
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.top-center",
                                                          value: {
                                                            content: _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                            ),
                                                            trigger:
                                                              "hover click"
                                                          },
                                                          expression:
                                                            "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                          modifiers: {
                                                            "top-center": true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "col-xs-12 current"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon:
                                                            "exclamation-triangle"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                              {
                                                                choice:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .STUDENT[
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "1"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].OLD_VALUE
                                                                    .length ===
                                                                  0
                                                                    ? '" "'
                                                                    : (_vm
                                                                        .studentDataCodex[
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "1"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .USE_CODEX
                                                                      ] &&
                                                                        _vm
                                                                          .studentDataCodex[
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "1"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .USE_CODEX
                                                                        ][
                                                                          _vm
                                                                            .formFieldSelectedValues
                                                                            .STUDENT[
                                                                            _vm
                                                                              .studentDataFields
                                                                              .GROUPS[
                                                                              "1"
                                                                            ]
                                                                              .COLUMNS[
                                                                              column
                                                                            ]
                                                                              .SAP_FIELD
                                                                          ]
                                                                            .OLD_VALUE
                                                                        ] &&
                                                                        _vm
                                                                          .studentDataCodex[
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "1"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .USE_CODEX
                                                                        ][
                                                                          _vm
                                                                            .formFieldSelectedValues
                                                                            .STUDENT[
                                                                            _vm
                                                                              .studentDataFields
                                                                              .GROUPS[
                                                                              "1"
                                                                            ]
                                                                              .COLUMNS[
                                                                              column
                                                                            ]
                                                                              .SAP_FIELD
                                                                          ]
                                                                            .OLD_VALUE
                                                                        ]
                                                                          .DICT_DESC) ||
                                                                      ""
                                                              }
                                                            )
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t"
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      : [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              { staticClass: "col-xs-12" },
                                              [
                                                !_vm.isEmail(
                                                  _vm.studentDataFields.GROUPS[
                                                    "1"
                                                  ].COLUMNS[column].SAP_FIELD
                                                )
                                                  ? _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .formFieldSelectedValues
                                                              .STUDENT[
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            ].VALUE,
                                                          expression:
                                                            "formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        maxlength:
                                                          "" +
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .FIELD_LENGTH,
                                                        "aria-label":
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .DV_GROUP_DESC +
                                                          ", " +
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .FIELD_LABEL +
                                                          ", " +
                                                          _vm
                                                            .formFieldSelectedValues
                                                            .STUDENT[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["1"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          ].VALUE,
                                                        disabled: !!_vm.disabledMap[1].includes(
                                                          _vm.studentDataFields
                                                            .GROUPS["1"]
                                                            .COLUMNS[column]
                                                            .SAP_FIELD_RID
                                                        )
                                                      },
                                                      domProps: {
                                                        value:
                                                          _vm
                                                            .formFieldSelectedValues
                                                            .STUDENT[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["1"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          ].VALUE
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.saveChangedValue(
                                                            _vm
                                                              .formFieldSelectedValues
                                                              .STUDENT[
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            ]
                                                          )
                                                        },
                                                        input: function(
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          ) {
                                                            return
                                                          }
                                                          _vm.$set(
                                                            _vm
                                                              .formFieldSelectedValues
                                                              .STUDENT[
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            ],
                                                            "VALUE",
                                                            $event.target.value
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("ValidationProvider", {
                                                  attrs: {
                                                    name:
                                                      _vm.studentDataFields
                                                        .GROUPS["1"].COLUMNS[
                                                        column
                                                      ].FIELD_LABEL,
                                                    rules: "email"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(ref) {
                                                          var errors =
                                                            ref.errors
                                                          return _c("div", {}, [
                                                            _vm.isEmail(
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["1"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD
                                                            )
                                                              ? _c("input", {
                                                                  directives: [
                                                                    {
                                                                      name:
                                                                        "model",
                                                                      rawName:
                                                                        "v-model",
                                                                      value:
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .STUDENT[
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "1"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ].VALUE,
                                                                      expression:
                                                                        "formFieldSelectedValues.STUDENT[studentDataFields.GROUPS['1'].COLUMNS[column].SAP_FIELD].VALUE"
                                                                    }
                                                                  ],
                                                                  staticClass:
                                                                    "form-control",
                                                                  attrs: {
                                                                    type:
                                                                      "text",
                                                                    maxlength:
                                                                      "" +
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "1"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .FIELD_LENGTH,
                                                                    "aria-label":
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "1"
                                                                      ]
                                                                        .DV_GROUP_DESC +
                                                                      ", " +
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "1"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .FIELD_LABEL +
                                                                      ", " +
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .STUDENT[
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "1"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ].VALUE,
                                                                    disabled: !!_vm.disabledMap[1].includes(
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "1"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD_RID
                                                                    )
                                                                  },
                                                                  domProps: {
                                                                    value:
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .STUDENT[
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "1"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ].VALUE
                                                                  },
                                                                  on: {
                                                                    change: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.isEmailFormat(
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .STUDENT[
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "1"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ]
                                                                      )
                                                                    },
                                                                    input: function(
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .STUDENT[
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "1"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ],
                                                                        "VALUE",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "small",
                                                              {
                                                                staticClass:
                                                                  "text-danger"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    errors[0]
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].VALUE !==
                                          _vm.formFieldSelectedValues.STUDENT[
                                            _vm.studentDataFields.GROUPS["1"]
                                              .COLUMNS[column].SAP_FIELD
                                          ].OLD_VALUE
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "tooltip",
                                                          rawName:
                                                            "v-tooltip.top-center",
                                                          value: {
                                                            content: _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                            ),
                                                            trigger:
                                                              "hover click"
                                                          },
                                                          expression:
                                                            "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                          modifiers: {
                                                            "top-center": true
                                                          }
                                                        }
                                                      ],
                                                      staticClass:
                                                        "col-xs-12 current"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon:
                                                            "exclamation-triangle"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                              {
                                                                choice:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .STUDENT[
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "1"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].OLD_VALUE
                                                                    .length ===
                                                                  0
                                                                    ? '" "'
                                                                    : _vm
                                                                        .formFieldSelectedValues
                                                                        .STUDENT[
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "1"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ]
                                                                        .OLD_VALUE
                                                              }
                                                            )
                                                          ) +
                                                          " \n\t\t\t\t\t\t\t"
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              }
                            )
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-6 col-xs-offset-3",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          !!_vm.studentDataFields.GROUPS["2"].DV_GROUP_DESC
                            ? _c("h3", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("" + _vm.getHeaderTitle(2))) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.formFieldSelectedValues.ORDER, function(
                      contact,
                      contactIndex
                    ) {
                      return _c(
                        "div",
                        {
                          key: "contacts_data_" + contactIndex,
                          staticClass: "row"
                        },
                        [
                          _c(
                            "panel-basic",
                            {
                              staticClass: "contact-header",
                              class: { "rounded-top": contactIndex === 0 },
                              attrs: {
                                title:
                                  _vm.formFieldSelectedValues.CONTACTS[contact]
                                    .DETAILS.CONTACT_DESC +
                                  " - " +
                                  _vm.formFieldSelectedValues.CONTACTS[contact]
                                    .DETAILS.FIRST_NAME +
                                  " " +
                                  _vm.formFieldSelectedValues.CONTACTS[contact]
                                    .DETAILS.LAST_NAME,
                                id: "contacts_" + contactIndex,
                                collapsable: true,
                                "panel-class": "full-height"
                              }
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.formFieldSelectedValues.CONTACTS[
                                        contact
                                      ].DETAILS.CONTACT_DESC
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formFieldSelectedValues.CONTACTS[
                                        contact
                                      ].DETAILS.FIRST_NAME
                                    ) +
                                    " " +
                                    _vm._s(
                                      _vm.formFieldSelectedValues.CONTACTS[
                                        contact
                                      ].DETAILS.LAST_NAME
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.contactFieldOrderArray, function(
                                column,
                                columnIndex
                              ) {
                                return !(column === 18 || column === 17)
                                  ? _c(
                                      "div",
                                      {
                                        key: "contact_" + columnIndex,
                                        staticClass: "col-xs-12 col-md-4",
                                        staticStyle: { "min-height": "110px" }
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-xs-12",
                                              staticStyle: {
                                                "font-weight": "bold",
                                                display: "inline"
                                              }
                                            },
                                            [
                                              !!_vm.studentDataFields.GROUPS[
                                                "2"
                                              ].COLUMNS[column].HELP_TEXT
                                                ? _c("font-awesome-icon", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName:
                                                          "v-tooltip.top-center",
                                                        value: {
                                                          content:
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["2"]
                                                              .COLUMNS[column]
                                                              .HELP_TEXT,
                                                          trigger: "hover click"
                                                        },
                                                        expression:
                                                          "{content: studentDataFields.GROUPS['2'].COLUMNS[column].HELP_TEXT, trigger: 'hover click'}",
                                                        modifiers: {
                                                          "top-center": true
                                                        }
                                                      }
                                                    ],
                                                    attrs: {
                                                      icon: "question-circle"
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                [
                                                  !!_vm.CONTACTSTEXT[column]
                                                    ? [
                                                        _vm.CONTACTSTEXT[column]
                                                          .length > 0 &&
                                                        _vm.$t(
                                                          _vm.CONTACTSTEXT[
                                                            column
                                                          ]
                                                        ).length > 0
                                                          ? [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      _vm
                                                                        .CONTACTSTEXT[
                                                                        column
                                                                      ]
                                                                    )
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                          : [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                  _vm._s(
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ]
                                                                      .FIELD_LABEL
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t\t\t"
                                                              )
                                                            ]
                                                      ]
                                                    : [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["2"]
                                                                .COLUMNS[column]
                                                                .FIELD_LABEL
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _vm.studentDataFields.GROUPS[
                                          "2"
                                        ].COLUMNS[column].SAP_FIELD.includes(
                                          "FLG"
                                        )
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-xs-12"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c(
                                                            "sapphire-toggle",
                                                            {
                                                              staticClass:
                                                                "col-xs-6 col-md-4 col-lg-3",
                                                              attrs: {
                                                                ariaLabel: _vm.getAriaMessage(
                                                                  2,
                                                                  column,
                                                                  _vm.CONTACTSTEXT
                                                                )
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.saveChangedValue(
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ]
                                                                  )
                                                                }
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ],
                                                                    "VALUE",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].VALUE !==
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].OLD_VALUE
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip.top-center",
                                                              value: {
                                                                content: _vm.$t(
                                                                  "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                                ),
                                                                trigger:
                                                                  "hover click"
                                                              },
                                                              expression:
                                                                "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                              modifiers: {
                                                                "top-center": true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-xs-12 current"
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "exclamation-triangle"
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                                  {
                                                                    choice:
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ]
                                                                        .OLD_VALUE ===
                                                                      "Y"
                                                                        ? _vm.$t(
                                                                            "MAIN_CONTENT.commonContent.yesLabel"
                                                                          )
                                                                        : _vm.$t(
                                                                            "MAIN_CONTENT.commonContent.noLabel"
                                                                          )
                                                                  }
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : _vm.studentDataFields.GROUPS["2"]
                                              .COLUMNS[column].USE_CODEX
                                              .length > 0
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-xs-12"
                                                    },
                                                    [
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ][
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ].SAP_FIELD
                                                                ].VALUE,
                                                              expression:
                                                                "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control",
                                                          attrs: {
                                                            "aria-label":
                                                              "Student contact " +
                                                              _vm
                                                                .formFieldSelectedValues
                                                                .CONTACTS[
                                                                contact
                                                              ].DETAILS
                                                                .CONTACT_DESC +
                                                              " - " +
                                                              _vm
                                                                .formFieldSelectedValues
                                                                .CONTACTS[
                                                                contact
                                                              ].DETAILS
                                                                .FIRST_NAME +
                                                              " " +
                                                              _vm
                                                                .formFieldSelectedValues
                                                                .CONTACTS[
                                                                contact
                                                              ].DETAILS
                                                                .LAST_NAME +
                                                              ", " +
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["2"]
                                                                .COLUMNS[column]
                                                                .FIELD_LABEL +
                                                              ", " +
                                                              _vm
                                                                .formFieldSelectedValues
                                                                .CONTACTS[
                                                                contact
                                                              ][
                                                                _vm
                                                                  .studentDataFields
                                                                  .GROUPS["2"]
                                                                  .COLUMNS[
                                                                  column
                                                                ].SAP_FIELD
                                                              ].VALUE,
                                                            disabled: !!_vm.disabledMap[2].includes(
                                                              _vm
                                                                .studentDataFields
                                                                .GROUPS["2"]
                                                                .COLUMNS[column]
                                                                .SAP_FIELD_RID
                                                            )
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$selectedVal = Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function(
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(function(
                                                                    o
                                                                  ) {
                                                                    var val =
                                                                      "_value" in
                                                                      o
                                                                        ? o._value
                                                                        : o.value
                                                                    return val
                                                                  })
                                                                _vm.$set(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ],
                                                                  "VALUE",
                                                                  $event.target
                                                                    .multiple
                                                                    ? $$selectedVal
                                                                    : $$selectedVal[0]
                                                                )
                                                              },
                                                              function($event) {
                                                                return _vm.saveChangedValue(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ]
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        },
                                                        _vm._l(
                                                          _vm.studentDataCodex[
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["2"]
                                                              .COLUMNS[column]
                                                              .USE_CODEX
                                                          ],
                                                          function(codex, key) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key:
                                                                  "CODEX_" +
                                                                  key,
                                                                domProps: {
                                                                  value:
                                                                    codex.DICT_CODE
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      codex.DICT_DESC
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].VALUE !==
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].OLD_VALUE
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip.top-center",
                                                              value: {
                                                                content: _vm.$t(
                                                                  "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                                ),
                                                                trigger:
                                                                  "hover click"
                                                              },
                                                              expression:
                                                                "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                              modifiers: {
                                                                "top-center": true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-xs-12 current"
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "exclamation-triangle"
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(
                                                            "\n\t\t\t\t\t\t\t\t" +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                                  {
                                                                    choice:
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ]
                                                                        .OLD_VALUE
                                                                        .length ===
                                                                      0
                                                                        ? '" "'
                                                                        : (_vm
                                                                            .studentDataCodex[
                                                                            _vm
                                                                              .studentDataFields
                                                                              .GROUPS[
                                                                              "2"
                                                                            ]
                                                                              .COLUMNS[
                                                                              column
                                                                            ]
                                                                              .USE_CODEX
                                                                          ] &&
                                                                            _vm
                                                                              .studentDataCodex[
                                                                              _vm
                                                                                .studentDataFields
                                                                                .GROUPS[
                                                                                "2"
                                                                              ]
                                                                                .COLUMNS[
                                                                                column
                                                                              ]
                                                                                .USE_CODEX
                                                                            ][
                                                                              _vm
                                                                                .formFieldSelectedValues
                                                                                .CONTACTS[
                                                                                contact
                                                                              ][
                                                                                _vm
                                                                                  .studentDataFields
                                                                                  .GROUPS[
                                                                                  "2"
                                                                                ]
                                                                                  .COLUMNS[
                                                                                  column
                                                                                ]
                                                                                  .SAP_FIELD
                                                                              ]
                                                                                .OLD_VALUE
                                                                            ] &&
                                                                            _vm
                                                                              .studentDataCodex[
                                                                              _vm
                                                                                .studentDataFields
                                                                                .GROUPS[
                                                                                "2"
                                                                              ]
                                                                                .COLUMNS[
                                                                                column
                                                                              ]
                                                                                .USE_CODEX
                                                                            ][
                                                                              _vm
                                                                                .formFieldSelectedValues
                                                                                .CONTACTS[
                                                                                contact
                                                                              ][
                                                                                _vm
                                                                                  .studentDataFields
                                                                                  .GROUPS[
                                                                                  "2"
                                                                                ]
                                                                                  .COLUMNS[
                                                                                  column
                                                                                ]
                                                                                  .SAP_FIELD
                                                                              ]
                                                                                .OLD_VALUE
                                                                            ]
                                                                              .DICT_DESC) ||
                                                                          ""
                                                                  }
                                                                )
                                                              ) +
                                                              "\n\t\t\t\t\t\t\t\t"
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-xs-12"
                                                    },
                                                    [
                                                      _vm.studentDataFields.GROUPS[
                                                        "2"
                                                      ].COLUMNS[
                                                        column
                                                      ].SAP_FIELD.indexOf(
                                                        "_ECO"
                                                      ) >= 0
                                                        ? _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                expression:
                                                                  "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "form-control",
                                                            staticStyle: {
                                                              width: "75px"
                                                            },
                                                            attrs: {
                                                              type: "number",
                                                              min: "1",
                                                              max: "99",
                                                              maxlength:
                                                                "" +
                                                                _vm
                                                                  .studentDataFields
                                                                  .GROUPS["2"]
                                                                  .COLUMNS[
                                                                  column
                                                                ].FIELD_LENGTH,
                                                              "aria-label":
                                                                "Student contact " +
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ].DETAILS
                                                                  .CONTACT_DESC +
                                                                " - " +
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ].DETAILS
                                                                  .FIRST_NAME +
                                                                " " +
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ].DETAILS
                                                                  .LAST_NAME +
                                                                ", " +
                                                                _vm
                                                                  .studentDataFields
                                                                  .GROUPS["2"]
                                                                  .COLUMNS[
                                                                  column
                                                                ].FIELD_LABEL +
                                                                ", " +
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ][
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ].SAP_FIELD
                                                                ].VALUE,
                                                              disabled: !!_vm.disabledMap[2].includes(
                                                                _vm
                                                                  .studentDataFields
                                                                  .GROUPS["2"]
                                                                  .COLUMNS[
                                                                  column
                                                                ].SAP_FIELD_RID
                                                              )
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm
                                                                  .formFieldSelectedValues
                                                                  .CONTACTS[
                                                                  contact
                                                                ][
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ].SAP_FIELD
                                                                ].VALUE
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.saveChangedValue(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ]
                                                                )
                                                              },
                                                              input: function(
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                ) {
                                                                  return
                                                                }
                                                                _vm.$set(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ],
                                                                  "VALUE",
                                                                  $event.target
                                                                    .value
                                                                )
                                                              }
                                                            }
                                                          })
                                                        : !_vm.isEmail(
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["2"]
                                                              .COLUMNS[column]
                                                              .SAP_FIELD
                                                          )
                                                        ? (_vm.studentDataFields.GROUPS[
                                                            "2"
                                                          ].COLUMNS[
                                                            column
                                                          ].SAP_FIELD.indexOf(
                                                            "_ECO"
                                                          ) >= 0
                                                            ? "number"
                                                            : "text") ===
                                                          "checkbox"
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ].VALUE,
                                                                  expression:
                                                                    "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                min: "1",
                                                                max: "99",
                                                                maxlength:
                                                                  "" +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LENGTH,
                                                                "aria-label":
                                                                  "Student contact " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .CONTACT_DESC +
                                                                  " - " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .FIRST_NAME +
                                                                  " " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .LAST_NAME +
                                                                  ", " +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LABEL +
                                                                  ", " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                disabled: !!_vm.disabledMap[2].includes(
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .SAP_FIELD_RID
                                                                ),
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                checked: Array.isArray(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE
                                                                )
                                                                  ? _vm._i(
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ].VALUE,
                                                                      null
                                                                    ) > -1
                                                                  : _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ].VALUE
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .CONTACTS[
                                                                          contact
                                                                        ][
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "2"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ].VALUE,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c = $$el.checked
                                                                        ? true
                                                                        : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v = null,
                                                                        $$i = _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .formFieldSelectedValues
                                                                              .CONTACTS[
                                                                              contact
                                                                            ][
                                                                              _vm
                                                                                .studentDataFields
                                                                                .GROUPS[
                                                                                "2"
                                                                              ]
                                                                                .COLUMNS[
                                                                                column
                                                                              ]
                                                                                .SAP_FIELD
                                                                            ],
                                                                            "VALUE",
                                                                            $$a.concat(
                                                                              [
                                                                                $$v
                                                                              ]
                                                                            )
                                                                          )
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          _vm.$set(
                                                                            _vm
                                                                              .formFieldSelectedValues
                                                                              .CONTACTS[
                                                                              contact
                                                                            ][
                                                                              _vm
                                                                                .studentDataFields
                                                                                .GROUPS[
                                                                                "2"
                                                                              ]
                                                                                .COLUMNS[
                                                                                column
                                                                              ]
                                                                                .SAP_FIELD
                                                                            ],
                                                                            "VALUE",
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              )
                                                                          )
                                                                      }
                                                                    } else {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .CONTACTS[
                                                                          contact
                                                                        ][
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "2"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ],
                                                                        "VALUE",
                                                                        $$c
                                                                      )
                                                                    }
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.saveChangedValue(
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ]
                                                                    )
                                                                  }
                                                                ]
                                                              }
                                                            })
                                                          : (_vm.studentDataFields.GROUPS[
                                                              "2"
                                                            ].COLUMNS[
                                                              column
                                                            ].SAP_FIELD.indexOf(
                                                              "_ECO"
                                                            ) >= 0
                                                              ? "number"
                                                              : "text") ===
                                                            "radio"
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ].VALUE,
                                                                  expression:
                                                                    "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                min: "1",
                                                                max: "99",
                                                                maxlength:
                                                                  "" +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LENGTH,
                                                                "aria-label":
                                                                  "Student contact " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .CONTACT_DESC +
                                                                  " - " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .FIRST_NAME +
                                                                  " " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .LAST_NAME +
                                                                  ", " +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LABEL +
                                                                  ", " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                disabled: !!_vm.disabledMap[2].includes(
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .SAP_FIELD_RID
                                                                ),
                                                                type: "radio"
                                                              },
                                                              domProps: {
                                                                checked: _vm._q(
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                  null
                                                                )
                                                              },
                                                              on: {
                                                                change: [
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.$set(
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ],
                                                                      "VALUE",
                                                                      null
                                                                    )
                                                                  },
                                                                  function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.saveChangedValue(
                                                                      _vm
                                                                        .formFieldSelectedValues
                                                                        .CONTACTS[
                                                                        contact
                                                                      ][
                                                                        _vm
                                                                          .studentDataFields
                                                                          .GROUPS[
                                                                          "2"
                                                                        ]
                                                                          .COLUMNS[
                                                                          column
                                                                        ]
                                                                          .SAP_FIELD
                                                                      ]
                                                                    )
                                                                  }
                                                                ]
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ].VALUE,
                                                                  expression:
                                                                    "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "form-control",
                                                              attrs: {
                                                                min: "1",
                                                                max: "99",
                                                                maxlength:
                                                                  "" +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LENGTH,
                                                                "aria-label":
                                                                  "Student contact " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .CONTACT_DESC +
                                                                  " - " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .FIRST_NAME +
                                                                  " " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ].DETAILS
                                                                    .LAST_NAME +
                                                                  ", " +
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .FIELD_LABEL +
                                                                  ", " +
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE,
                                                                disabled: !!_vm.disabledMap[2].includes(
                                                                  _vm
                                                                    .studentDataFields
                                                                    .GROUPS["2"]
                                                                    .COLUMNS[
                                                                    column
                                                                  ]
                                                                    .SAP_FIELD_RID
                                                                ),
                                                                type:
                                                                  _vm.studentDataFields.GROUPS[
                                                                    "2"
                                                                  ].COLUMNS[
                                                                    column
                                                                  ].SAP_FIELD.indexOf(
                                                                    "_ECO"
                                                                  ) >= 0
                                                                    ? "number"
                                                                    : "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .formFieldSelectedValues
                                                                    .CONTACTS[
                                                                    contact
                                                                  ][
                                                                    _vm
                                                                      .studentDataFields
                                                                      .GROUPS[
                                                                      "2"
                                                                    ].COLUMNS[
                                                                      column
                                                                    ].SAP_FIELD
                                                                  ].VALUE
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.saveChangedValue(
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ]
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    _vm
                                                                      .formFieldSelectedValues
                                                                      .CONTACTS[
                                                                      contact
                                                                    ][
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    ],
                                                                    "VALUE",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        attrs: {
                                                          name:
                                                            _vm
                                                              .studentDataFields
                                                              .GROUPS["2"]
                                                              .COLUMNS[column]
                                                              .FIELD_LABEL,
                                                          rules: "email"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                return _c(
                                                                  "div",
                                                                  {},
                                                                  [
                                                                    _vm.isEmail(
                                                                      _vm
                                                                        .studentDataFields
                                                                        .GROUPS[
                                                                        "2"
                                                                      ].COLUMNS[
                                                                        column
                                                                      ]
                                                                        .SAP_FIELD
                                                                    )
                                                                      ? _c(
                                                                          "input",
                                                                          {
                                                                            directives: [
                                                                              {
                                                                                name:
                                                                                  "model",
                                                                                rawName:
                                                                                  "v-model",
                                                                                value:
                                                                                  _vm
                                                                                    .formFieldSelectedValues
                                                                                    .CONTACTS[
                                                                                    contact
                                                                                  ][
                                                                                    _vm
                                                                                      .studentDataFields
                                                                                      .GROUPS[
                                                                                      "2"
                                                                                    ]
                                                                                      .COLUMNS[
                                                                                      column
                                                                                    ]
                                                                                      .SAP_FIELD
                                                                                  ]
                                                                                    .VALUE,
                                                                                expression:
                                                                                  "formFieldSelectedValues.CONTACTS[contact][studentDataFields.GROUPS['2'].COLUMNS[column].SAP_FIELD].VALUE"
                                                                              }
                                                                            ],
                                                                            staticClass:
                                                                              "form-control",
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              maxlength:
                                                                                "" +
                                                                                _vm
                                                                                  .studentDataFields
                                                                                  .GROUPS[
                                                                                  "2"
                                                                                ]
                                                                                  .COLUMNS[
                                                                                  column
                                                                                ]
                                                                                  .FIELD_LENGTH,
                                                                              "aria-label":
                                                                                "Student contact " +
                                                                                _vm
                                                                                  .formFieldSelectedValues
                                                                                  .CONTACTS[
                                                                                  contact
                                                                                ]
                                                                                  .DETAILS
                                                                                  .CONTACT_DESC +
                                                                                " - " +
                                                                                _vm
                                                                                  .formFieldSelectedValues
                                                                                  .CONTACTS[
                                                                                  contact
                                                                                ]
                                                                                  .DETAILS
                                                                                  .FIRST_NAME +
                                                                                " " +
                                                                                _vm
                                                                                  .formFieldSelectedValues
                                                                                  .CONTACTS[
                                                                                  contact
                                                                                ]
                                                                                  .DETAILS
                                                                                  .LAST_NAME +
                                                                                ", " +
                                                                                _vm
                                                                                  .studentDataFields
                                                                                  .GROUPS[
                                                                                  "2"
                                                                                ]
                                                                                  .COLUMNS[
                                                                                  column
                                                                                ]
                                                                                  .FIELD_LABEL +
                                                                                ", " +
                                                                                _vm
                                                                                  .formFieldSelectedValues
                                                                                  .CONTACTS[
                                                                                  contact
                                                                                ][
                                                                                  _vm
                                                                                    .studentDataFields
                                                                                    .GROUPS[
                                                                                    "2"
                                                                                  ]
                                                                                    .COLUMNS[
                                                                                    column
                                                                                  ]
                                                                                    .SAP_FIELD
                                                                                ]
                                                                                  .VALUE,
                                                                              disabled: !!_vm.disabledMap[2].includes(
                                                                                _vm
                                                                                  .studentDataFields
                                                                                  .GROUPS[
                                                                                  "2"
                                                                                ]
                                                                                  .COLUMNS[
                                                                                  column
                                                                                ]
                                                                                  .SAP_FIELD_RID
                                                                              )
                                                                            },
                                                                            domProps: {
                                                                              value:
                                                                                _vm
                                                                                  .formFieldSelectedValues
                                                                                  .CONTACTS[
                                                                                  contact
                                                                                ][
                                                                                  _vm
                                                                                    .studentDataFields
                                                                                    .GROUPS[
                                                                                    "2"
                                                                                  ]
                                                                                    .COLUMNS[
                                                                                    column
                                                                                  ]
                                                                                    .SAP_FIELD
                                                                                ]
                                                                                  .VALUE
                                                                            },
                                                                            on: {
                                                                              change: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.isEmailFormat(
                                                                                  _vm
                                                                                    .formFieldSelectedValues
                                                                                    .CONTACTS[
                                                                                    contact
                                                                                  ][
                                                                                    _vm
                                                                                      .studentDataFields
                                                                                      .GROUPS[
                                                                                      "2"
                                                                                    ]
                                                                                      .COLUMNS[
                                                                                      column
                                                                                    ]
                                                                                      .SAP_FIELD
                                                                                  ]
                                                                                )
                                                                              },
                                                                              input: function(
                                                                                $event
                                                                              ) {
                                                                                if (
                                                                                  $event
                                                                                    .target
                                                                                    .composing
                                                                                ) {
                                                                                  return
                                                                                }
                                                                                _vm.$set(
                                                                                  _vm
                                                                                    .formFieldSelectedValues
                                                                                    .CONTACTS[
                                                                                    contact
                                                                                  ][
                                                                                    _vm
                                                                                      .studentDataFields
                                                                                      .GROUPS[
                                                                                      "2"
                                                                                    ]
                                                                                      .COLUMNS[
                                                                                      column
                                                                                    ]
                                                                                      .SAP_FIELD
                                                                                  ],
                                                                                  "VALUE",
                                                                                  $event
                                                                                    .target
                                                                                    .value
                                                                                )
                                                                              }
                                                                            }
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "small",
                                                                      {
                                                                        staticClass:
                                                                          "text-danger"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            errors[0]
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].VALUE !==
                                              _vm.formFieldSelectedValues
                                                .CONTACTS[contact][
                                                _vm.studentDataFields.GROUPS[
                                                  "2"
                                                ].COLUMNS[column].SAP_FIELD
                                              ].OLD_VALUE
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "tooltip",
                                                              rawName:
                                                                "v-tooltip.top-center",
                                                              value: {
                                                                content: _vm.$t(
                                                                  "MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage"
                                                                ),
                                                                trigger:
                                                                  "hover click"
                                                              },
                                                              expression:
                                                                "{content: $t('MAIN_CONTENT.ChangeStudentData.schoolNotificationMessage'), trigger: 'hover click'}",
                                                              modifiers: {
                                                                "top-center": true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "col-xs-12 current"
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon:
                                                                  "exclamation-triangle"
                                                              }
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "MAIN_CONTENT.ChangeStudentData.currentWithColon",
                                                                    {
                                                                      choice:
                                                                        _vm
                                                                          .formFieldSelectedValues
                                                                          .CONTACTS[
                                                                          contact
                                                                        ][
                                                                          _vm
                                                                            .studentDataFields
                                                                            .GROUPS[
                                                                            "2"
                                                                          ]
                                                                            .COLUMNS[
                                                                            column
                                                                          ]
                                                                            .SAP_FIELD
                                                                        ]
                                                                          .OLD_VALUE
                                                                    }
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t"
                                                            )
                                                          ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                        _vm._v(" "),
                                        _c("br", {
                                          key: "contacts_br_" + contactIndex
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm.$t(
                    "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                  )
                ) +
                "\n\t"
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }